var sunziPhotoConfig = {
    "wallet": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/CQB33S_1.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/CQB33S_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/CQB33S_2.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/CQB33S_2ai.png"
            }
        ],
        "supportSort": true
    },
    "engraved": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_2ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_3ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_4ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "locketNecklace": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_2ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_3ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_4ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CQB29": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/CQB29_1.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/CQB29_1ai.png"
            },
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/CQB29_2.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/CQB29_2ai.png"
            }
        ],
        "supportSort": true
    },
    "CQB30S": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/CQB30S_1.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/CQB30S_1ai.png"
            },
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/CQB30S_2.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/CQB30S_2ai.png"
            }
        ],
        "supportSort": true
    },
    "CQB33S": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/CQB33S_1.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/CQB33S_1ai.png"
            },
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/CQB33S_2.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/CQB33S_2ai.png"
            }
        ],
        "supportSort": true
    },
    "CQB63S": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/CQB63S_1.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/CQB63S_1ai.png"
            },
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/CQB63S_2.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/CQB63S_2ai.png"
            }
        ],
        "supportSort": true
    },
    "PED001": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/PED001_1.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/PED001_1ai.png"
            },
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/PED001_2.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/PED001_2ai.png"
            }
        ],
        "supportSort": true
    },
    "PED001X01": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/PED001X01_1.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/PED001X01_1ai.png"
            },
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/PED001X01_2.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/PED001X01_2ai.png"
            }
        ],
        "supportSort": true
    },
    "PED002": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/PED002_1.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/PED002_1ai.png"
            },
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/PED002_2.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/PED002_2ai.png"
            }
        ],
        "supportSort": true
    },
    "SCQB03S": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/SCQB03S_1.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/SCQB03S_1ai.png"
            },
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/SCQB03S_2.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/SCQB03S_2ai.png"
            }
        ],
        "supportSort": true
    },
    "SCQB06S": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/SCQB06S_1.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/SCQB06S_1ai.png"
            },
            {
                "type": "multiphoto",
                "cropImage": "https://pic.stylelab.com/img/photo/SCQB06S_2.png",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/SCQB06S_2ai.png"
            }
        ],
        "supportSort": true
    },
    "SKL044X02": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL044X02_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL044X02_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL044X02_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL044X02_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "SKL045X02": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL045X02_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL045X02_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL045X02_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL045X02_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "SKL046X02": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL046X02_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL046X02_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL046X02_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL046X02_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "SKL047X02": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL047X02_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL047X02_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL047X02_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL047X02_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "SKL048X02": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL048X02_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL048X02_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL048X02_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL048X02_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "SKL049X02": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL049X02_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL049X02_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL049X02_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL049X02_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "SKL052": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL052_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL052_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL052_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/SKL052_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XBT009": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XBT009X02": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X02_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X02_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X02_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X02_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XBT009X03": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X03_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X03_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X03_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X03_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XBT009X04": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X04_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X04_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X04_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X04_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XBT009X05": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X05_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X05_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X05_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XBT009X05_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XHD045": {
        "carving": [],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XHD045_1.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XHD045_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XHD045_2.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XHD045_2ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XHD045_3.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XHD045_3ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/XHD045_4.png",
                "addPrice": "",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/XHD045_4ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XHD036": {
        "carving": [
            {
                "enable": true,
                "hasPhoto": false,
                "sku": "XHD036",
                "in": "XHD036-IN.png",
                "out": "XHD036-OUT.png",
                "showSize": true,
                "showFont": true,
                "maxLength": 300,
                "engravingSizeOptions": [
                    {
                        "value": "20",
                        "label": "20"
                    },
                    {
                        "value": "30",
                        "label": "30"
                    },
                    {
                        "value": "40",
                        "label": "40"
                    },
                    {
                        "value": "50",
                        "label": "50"
                    },
                    {
                        "value": "60",
                        "label": "60"
                    }
                ],
                "engravingFontOptions": [
                    {
                        "value": "TimesNewRoman",
                        "label": "TimesNewRoman"
                    },
                    {
                        "value": "NexaScript-Free",
                        "label": "NexaScript"
                    },
                    {
                        "value": "AppleChancery",
                        "label": "AppleChancery"
                    },
                    {
                        "value": "holyunion",
                        "label": "Holyunion"
                    },
                    {
                        "value": "AlluraRegular",
                        "label": "AlluraRegular"
                    }
                ],
                "coors": [
                    {
                        "left": 95,
                        "top": 70,
                        "limit": "100",
                        "angle": "0",
                        "textColor": "black",
                        "shadowColor": "white",
                        "direction": "",
                        "banDrag": "0",
                        "lineHeight": "1",
                        "rows": "1",
                        "resize": "none",
                        "text": "",
                        "size": 20,
                        "font": "TimesNewRoman"
                    }
                ]
            }
        ],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/XHD036_1.png?q213",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/XHD036_1ai.png?q213"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/XHD036_2.png?q213",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/XHD036_2ai.png?q213"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/XHD036_3.png?q213",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/XHD036_3ai.png?q213"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/XHD036_4.png?q213",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/XHD036_4ai.png?q213"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/XHD036_5.png?q213",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/XHD036_5ai.png?q213"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XHD036X01": {
        "carving": [
            {
                "enable": true,
                "hasPhoto": false,
                "sku": "XHD036",
                "in": "XHD036-IN.png",
                "out": "XHD036-OUT.png",
                "showSize": true,
                "showFont": true,
                "maxLength": 300,
                "engravingSizeOptions": [
                    {
                        "value": "20",
                        "label": "20"
                    },
                    {
                        "value": "30",
                        "label": "30"
                    },
                    {
                        "value": "40",
                        "label": "40"
                    },
                    {
                        "value": "50",
                        "label": "50"
                    },
                    {
                        "value": "60",
                        "label": "60"
                    }
                ],
                "engravingFontOptions": [
                    {
                        "value": "TimesNewRoman",
                        "label": "TimesNewRoman"
                    },
                    {
                        "value": "NexaScript-Free",
                        "label": "NexaScript"
                    },
                    {
                        "value": "AppleChancery",
                        "label": "AppleChancery"
                    },
                    {
                        "value": "holyunion",
                        "label": "Holyunion"
                    },
                    {
                        "value": "AlluraRegular",
                        "label": "AlluraRegular"
                    }
                ],
                "coors": [
                    {
                        "left": 95,
                        "top": 70,
                        "limit": "100",
                        "angle": "0",
                        "textColor": "black",
                        "shadowColor": "white",
                        "direction": "",
                        "banDrag": "0",
                        "lineHeight": "1",
                        "rows": "1",
                        "resize": "none",
                        "text": "",
                        "size": 20,
                        "font": "TimesNewRoman"
                    }
                ]
            }
        ],
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/XHD036_1.png?q213",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/XHD036_1ai.png?q213"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/XHD036_2.png?q213",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/XHD036_2ai.png?q213"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/XHD036_3.png?q213",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/XHD036_3ai.png?q213"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/XHD036_4.png?q213",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/XHD036_4ai.png?q213"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/XHD036_5.png?q213",
                "addPrice": "",
                "aiImage": "https://pic.stylelab.com/img/photo/XHD036_5ai.png?q213"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CYH033X01": {
        "handleType": "cropper",
        "imageList": [
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CYH033X02": {
        "handleType": "cropper",
        "imageList": [
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CYH033X03": {
        "handleType": "cropper",
        "imageList": [
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CYH033X04": {
        "handleType": "cropper",
        "imageList": [
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CYH033X05": {
        "handleType": "cropper",
        "imageList": [
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 572
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XBT050A": {
        "handleType": "cropper",
        "imageList": [
            {
                "type": "multipic",
                "width": 572,
                "height": 762
            },
            {
                "type": "multipic",
                "width": 572,
                "height": 762
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XHD058A": {
        "handleType": "cropper",
        "imageList": [
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            },
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            },
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            },
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XHD058B": {
        "handleType": "cropper",
        "imageList": [
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            },
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            },
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            },
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XHD058C": {
        "handleType": "cropper",
        "imageList": [
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            },
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            },
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            },
            {
                "type": "multipic",
                "width": 618,
                "height": 690
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XBT050B": {
        "handleType": "cropper",
        "imageList": [
            {
                "type": "multipic",
                "width": 762,
                "height": 572
            },
            {
                "type": "multipic",
                "width": 762,
                "height": 572
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CBS139X01": {
        "handleType": "cropai",
        "aiToOrigin": true,
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X01_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X01_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X01_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X01_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X01_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X01_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X01_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X01_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X01_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X01_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X01_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X01_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X01_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X01_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X01_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X01_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X01_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X01_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X01_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X01_10ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CBS139X02": {
        "handleType": "cropai",
        "aiToOrigin": true,
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X02_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X02_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X02_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X02_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X02_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X02_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X02_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X02_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X02_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X02_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X02_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X02_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X02_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X02_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X02_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X02_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X02_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X02_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X02_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X02_10ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CBS139X03": {
        "handleType": "cropai",
        "aiToOrigin": true,
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X03_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X03_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X03_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X03_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X03_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X03_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X03_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X03_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X03_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X03_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X03_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X03_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X03_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X03_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X03_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X03_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X03_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X03_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X03_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X03_10ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CBS139X04": {
        "handleType": "cropai",
        "aiToOrigin": true,
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X04_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X04_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X04_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X04_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X04_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X04_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X04_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X04_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X04_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X04_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X04_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X04_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X04_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X04_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X04_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X04_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X04_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X04_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X04_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X04_10ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CBS139X05": {
        "handleType": "cropai",
        "aiToOrigin": true,
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X05_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X05_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X05_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X05_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X05_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X05_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X05_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X05_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X05_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X05_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X05_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X05_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X05_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X05_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X05_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X05_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X05_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X05_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X05_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X05_10ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CBS139X06": {
        "handleType": "cropai",
        "aiToOrigin": true,
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X06_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X06_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X06_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X06_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X06_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X06_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X06_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X06_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X06_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X06_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X06_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X06_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X06_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X06_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X06_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X06_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X06_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X06_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS139X06_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS139X06_10ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "DTH009X05": {
        "handleType": "cropai",
        "aiToOrigin": true,
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_10ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_11.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_11ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_12.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_12ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_13.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_13ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_14.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_14ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_15.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_15ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_16.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_16ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X05_17.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X05_17ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CARD27X01": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X01_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X01_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X01_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X01_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X01_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X01_3ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X02": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X02_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X02_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X02_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X02_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X02_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X02_3ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X03": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X03_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X03_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X03_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X03_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X03_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X03_3ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X04": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X04_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X04_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X04_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X04_2ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X05": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X05_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X05_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X05_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X05_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X05_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X05_3ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X06": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X06_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X06_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X06_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X06_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X06_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X06_3ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X07": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X07_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X07_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X07_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X07_2ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X08": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X08_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X08_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X08_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X08_2ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X09": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X09_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X09_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X09_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X09_2ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X12": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X12_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X12_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X12_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X12_2ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X13": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X13_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X13_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X13_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X13_2ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X15": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X15_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X15_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X15_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X15_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X15_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X15_3ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X16": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X16_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X16_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X16_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X16_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X16_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X16_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X16_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X16_4ai.png"
            }
        ],
        "supportSort": true
    },
    "CARD27X17": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X17_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X17_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X17_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X17_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CARD27X17_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CARD27X17_3ai.png"
            }
        ],
        "supportSort": true
    },
    "CBS004X01": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X01_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X01_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X01_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X01_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X01_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X01_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X01_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X01_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X01_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X01_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X01_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X01_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X01_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X01_7ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CBS004X02": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X02_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X02_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X02_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X02_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X02_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X02_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X02_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X02_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X02_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X02_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X02_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X02_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X02_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X02_7ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CBS004X03": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X03_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X03_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X03_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X03_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X03_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X03_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X03_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X03_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X03_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X03_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X03_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X03_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X03_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X03_7ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CBS004X04": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X04_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X04_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X04_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X04_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X04_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X04_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X04_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X04_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X04_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X04_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X04_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X04_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X04_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X04_7ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "CBS004X05": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X05_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X05_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X05_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X05_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X05_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X05_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X05_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X05_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X05_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X05_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X05_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X05_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/CBS004X05_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/CBS004X05_7ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "DTH009X01": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_10ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_11.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_11ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_12.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_12ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_13.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_13ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_14.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_14ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_15.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_15ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_16.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_16ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X01_17.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X01_17ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "DTH009X02": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_10ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_11.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_11ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_12.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_12ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_13.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_13ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_14.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_14ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_15.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_15ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_16.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_16ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X02_17.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X02_17ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "DTH009X03": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_10ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_11.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_11ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_12.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_12ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_13.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_13ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_14.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_14ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_15.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_15ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_16.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_16ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X03_17.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X03_17ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "DTH009X04": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_1ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_2ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_3ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_4ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_5.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_5ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_6.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_6ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_7.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_7ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_8.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_8ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_9.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_9ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_10.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_10ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_11.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_11ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_12.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_12ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_13.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_13ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_14.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_14ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_15.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_15ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_16.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_16ai.png"
            },
            {
                "type": "multiphotos",
                "cropImage": "https://pic.stylelab.com/img/photo/DTH009X04_17.png",
                "aiImage": "https://pic.stylelab.com/img/photo/DTH009X04_17ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "PNL001X01": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X01_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X01_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X01_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X01_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "PNL001X02": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X02_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X02_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X02_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X02_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "PNL001X03": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X03_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X03_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X03_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X03_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "PNL001X04": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X04_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X04_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X04_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X04_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "PNL001X05": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X05_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X05_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X05_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X05_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "PNL001X06": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X06_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X06_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/PNL001X06_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/PNL001X06_2ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "TC347A": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_2ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_3ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_4ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "TC347AX01": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_2ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_3ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347A_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347A_4ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "TC347B": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347B_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347B_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347B_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347B_2ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347B_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347B_3ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347B_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347B_4ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "TC347BX01": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347BX01_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347BX01_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347BX01_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347BX01_2ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347BX01_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347BX01_3ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347BX01_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347BX01_4ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "TC347C": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347C_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347C_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347C_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347C_2ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347C_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347C_3ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347C_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347C_4ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "TC347CX01": {
        "handleType": "cropai",
        "imageList": [
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347CX01_1.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347CX01_1ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347CX01_2.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347CX01_2ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347CX01_3.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347CX01_3ai.png"
            },
            {
                "type": "multipic",
                "cropImage": "https://pic.stylelab.com/img/photo/TC347CX01_4.png",
                "aiImage": "https://pic.stylelab.com/img/photo/TC347CX01_4ai.png"
            }
        ],
        "supportSort": true,
        "needCompose": true
    },
    "XHD054": {
        "imageList": [
            {
                "type": "multipic",
                "width": 594,
                "height": 624
            },
            {
                "type": "multipic",
                "width": 594,
                "height": 624
            },
            {
                "type": "multipic",
                "width": 594,
                "height": 624
            },
            {
                "type": "multipic",
                "width": 594,
                "height": 624
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "DTH007X01": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "DTH007X02": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "DTH007X03": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "DTH007X04": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "DTH007X05": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "DTH007X06": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "XBT007A": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "XBT007AX01": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "XBT007AX02": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "XBT007AX03": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "XBT007AX04": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "XBT007AX05": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "XBT007B": {
        "imageList": [
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            },
            {
                "type": "multipic",
                "width": 600,
                "height": 600
            }
        ],
        "handleType": "cropper",
        "supportSort": true,
        "needCompose": true
    },
    "CQB27": {
        "imageList": [
            {
                "type": "multiphoto",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/CQB27_1.png",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/CQB27_1ai.png"
            },
            {
                "type": "multiphoto",
                "cropImage": "https:\/\/pic.stylelab.com\/img\/photo\/CQB27_1.png",
                "aiImage": "https:\/\/pic.stylelab.com\/img\/photo\/CQB27_1ai.png"
            }
        ],
        "handleType": "cropai",
        "supportSort": true
    }
}
